import React, { useContext, useCallback } from 'react';
import { ProductTypes } from '../../../enums/product-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { ProductDetailsContext } from '../context';
import style from '../style.module.css';

export const ProductTypeDropdown = () => {
  const { productType, setProductType, productId, setIsSaveInPlaceRequired } = useContext(ProductDetailsContext);

  const onProductTypeChange = useCallback(
    (value) => {
      setProductType(value);
      const isNew = !productId;
      if (isNew) {
        setIsSaveInPlaceRequired(value === ProductTypes.Parent.name);
      }
    },
    [setProductType, productId, setIsSaveInPlaceRequired],
  );

  return (
    <DropdownMenu dropdownMenuShouldHaveWidthOfButton variant='form'>
      <DropdownMenuToggler className={style['product-type-drop']}>
        {ProductTypes[productType]?.displayText ?? productType}
      </DropdownMenuToggler>
      {Object.values(ProductTypes).map((pType) => (
        <DropdownMenuItem
          key={pType.name}
          disabled={pType.name === ProductTypes.Variant.name}
          name={pType.name}
          onClick={onProductTypeChange}
        >
          {pType.displayText}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};
